<p-dropdown
  emptyFilterMessage=""
  [(ngModel)]="currentValue"
  (onChange)="handleSelection()"
  [styleClass]="baseStyle"
  [appendTo]="appendTo"
  [options]="selectItems"
  [filter]="filter"
  [autoDisplayFirst]="autoDisplayFirst"
  [placeholder]="placeholder"
  [disabled]="disabled"
  [dataKey]="dataKey"
  [virtualScroll]="virtualScroll"
  [itemSize]="virtualScrollSize"
  [filterPlaceholder]="filterPlaceHolder"
  [readonly]="readonly">
</p-dropdown>
